import { TourActionType } from 'src/sdk-components/VSObject';

export enum TagEventsType {
  Add = 'add',
  Edit = 'edit',
  EditMedia = 'edit_media',
  OpenTagIframe = 'open_tag_iframe'
}

export enum TagType {
  None = 'none',
  Text = 'text',
  Image = 'image',
  Gallery = 'gallery',
  Music = 'music',
  Video = 'video',
  Iframe = 'iframe',
  Tab = 'tab',
  Panorama = 'panorama',
  Menu = 'menu',
  Matterport = 'matterport',
  MatterportInstant = 'matterport-instant',
  Treedis = 'treedis',
  VideoChat = 'video-chat',
  ConferenceChat = 'conference-chat',
  Navigation = 'navigation'
}

export enum TagCategories {
  Media = 'media',
  Special = 'special',
  MoveTo = 'moveTo'
}

export const TagCategoriesTypes = {
  [TagCategories.Media]: [TourActionType.Gallery],
  [TagCategories.Special]: [
    TourActionType.ExperiencePopUp,
    TourActionType.Music,
    TourActionType.Iframe
  ],
  [TagCategories.MoveTo]: [
    TourActionType.Tab,
    TourActionType.Panorama,
    TourActionType.Matterport,
    TourActionType.MatterportInstant,
    TourActionType.Treedis
  ]
};
